import React from "react";
import ReactDOM from "react-dom";
import axios from 'axios';

import withRouter from '../libs/withRouter.jsx';
import withAuth from "../libs/withAuth.jsx";
import copyTextToClipboard from "../libs/copyTextToClipboard.jsx";
import Loader from "../libs/loader.jsx";
import Monday from "../auth/useMonday.jsx";


import { Button, Heading, TextField, Tooltip, Icon } from "@vibe/core";
import { Duplicate, Retry, Alert } from "@vibe/icons";

import mondaySdk from "monday-sdk-js";
const monday = mondaySdk();
monday.setApiVersion(config.monday_api.version);

class AccessToken extends React.Component
{
    constructor(props)
    {
        super(props);
        //console.log("AccessToken props",this.props);
        this.params = this.props.router.params;
        
        this.state = {
            'token': '',
            'personal_token': '',
            'personal_token_valid': (this.props.auth.personalToken!=='' && this.props.auth.personalTokenValid===false)?false:true,
            'account_id': null,
            'loading': false,
            'personal_loading': false,
            'revoke_loading': false,
        };
        
        this.loader = React.createRef();
    }
    
    copy(e)
    {
        //console.log('copy',e);
        copyTextToClipboard(this.state.token, 'Token copied to clipboard');
    }
    
    regenerate(e)
    {
        var this_component = this;
        //console.log('regenerate',e);
        
        this.setState({'loading':true});
        
        axios.get('/api/v1/access_token/regenerate', { 'params': {} } )
            .then(response => {
                //console.log(response);
                if(response.data.error==0)
                {
                    this_component.setState({'token': response.data.token});
                }
                
                this_component.setState({'loading':false});
            }).catch(error => {
                console.log('AccessToken regenerate error', error, error.response);

                if('error_message' in error.response.data)
                {
                    monday.execute("notice", { 
                        message: error.response.data.error_message,
                        type: "error", // or "error" (red), or "info" (blue)
                        timeout: 30000,
                    });
                }
                
                this_component.setState({'loading':false});
            });
    }
    
    savePersonalToken(e)
    {
        var this_component = this;
        
        this_component.setState({'personal_loading':true});
        
        var data = new FormData();
        data.append('personal_token', this_component.state.personal_token);
        
        axios.post('/api/v1/access_token/save_personal_token', data)
            .then(response => {

                if(response.data.error==0)
                {
                    this_component.setState({'personal_loading':false});
                    
                    if(response.data.valid == true)
                    {
                        this_component.props.auth.setPersonalTokenValid(true);
                        this_component.props.auth.setPersonalToken(this_component.state.personal_token);
                        Monday.setPersonalToken( this_component.state.personal_token?this_component.state.personal_token:false );
                        
                        this_component.setState({'personal_token_valid':true});
                        
                        monday.execute("notice", { 
                            message: 'Personal token saved successfully',
                            type: "success", // or "error" (red), or "info" (blue)
                            timeout: 10000,
                        });

                        //document.location.href = document.location.href;

                        //this_component.getToken();
                    }
                    else
                    {
                        //this_component.props.auth.setPersonalTokenValid(false);
                        this_component.setState({'personal_token_valid':false});
                        monday.execute("notice", { 
                            message: 'Validation error. Please enter a valid personal token',
                            type: "error", // or "error" (red), or "info" (blue)
                            timeout: 10000,
                        });
                        
                    }
                    
                    //console.log("auth",{...this_component.props.auth});
                }
                
                this_component.loader.current.hideLoader();
            })
            .catch(error => {
                console.log('Personal token save error', error, error.response);

                if('error_message' in error.response.data)
                {
                    monday.execute("notice", { 
                        message: error.response.data.error_message,
                        type: "error", // or "error" (red), or "info" (blue)
                        timeout: 30000,
                    });
                }
                
                this_component.setState({'personal_loading':false});
                //this_component.getToken();
            });
    }
    
    revokePersonalToken(e)
    {
        var this_component = this;
        
        this_component.setState({'revoke_loading':true});
        
        var data = new FormData();
        
        axios.post('/api/v1/access_token/revoke_personal_token', data)
            .then(response => {

                if(response.data.error==0)
                {
                    this_component.setState({'revoke_loading':false});
                        
                    this_component.props.auth.setPersonalTokenValid(true);
                    this_component.props.auth.setPersonalToken('');
                    this_component.setState({'personal_token':''});
                    Monday.setPersonalToken( false );

                    this_component.setState({'personal_token_valid':true});

                    monday.execute("notice", { 
                        message: 'Personal token successfully revoked',
                        type: "success", // or "error" (red), or "info" (blue)
                        timeout: 10000,
                    });

                    //document.location.href = document.location.href;

                    //this_component.getToken();
                }
                
                this_component.loader.current.hideLoader();
            })
            .catch(error => {
                
                console.log('Personal token revoke error', error, error.response);

                if('error_message' in error.response.data)
                {
                    monday.execute("notice", { 
                        message: error.response.data.error_message,
                        type: "error", // or "error" (red), or "info" (blue)
                        timeout: 30000,
                    });
                }
                
                this_component.setState({'revoke_loading':false});
                //this_component.getToken();
            });
    }
    
    
    
    onChangePersonalToken(value)
    {
        var this_component = this;
        this_component.setState({'personal_token': value});
    }
    
    componentDidMount()
    {
        var this_component = this;
        this.getToken();
        this.getAccountId();
    }
    
    getToken()
    {
        var this_component = this;
        
        this_component.loader.current.showLoader();
        
        axios.get('/api/v1/access_token/get', { 'params': {} } )
            .then(response => {
                //console.log(response);
                if(response.data.error==0)
                {
                    this_component.setState({'token': response.data.token});
                    this_component.setState({'personal_token': response.data.personal_token});
                    
                    if(response.data.personal_token_valid === false && response.data.personal_token !=='')
                    {
                        this_component.setState({'personal_token_valid': false});
                    }
                    else
                    {
                        this_component.setState({'personal_token_valid': true});
                    }
                    
                    this_component.props.auth.setPersonalToken(response.data.personal_token);
                    this_component.props.auth.setPersonalTokenValid(response.data.personal_token_valid);
                    
                    
                    if(response.data.personal_token_valid === false)
                    {
                        Monday.setPersonalToken( false );
                    }
                    else
                    {
                        if(response.data.personal_token !=='')
                        {
                           Monday.setPersonalToken( response.data.personal_token );
                        }
                    }
                    
                }
                this_component.loader.current.hideLoader();
            }).catch(error => {
                console.log('AccessToken getToken error', error, error.response);

                if('error_message' in error.response.data)
                {
                    monday.execute("notice", { 
                        message: error.response.data.error_message,
                        type: "error", // or "error" (red), or "info" (blue)
                        timeout: 30000,
                    });
                }
                
                this_component.loader.current.hideLoader();
            });
    }
    
    async getAccountId()
    {
        var this_component = this;
        let account_id = await Monday.getMondayAccountId(this_component.loader);
        
        //console.log('accessToken getAccountId', account_id);
        
        if(account_id)
        {
            this_component.setState({'account_id': account_id});
        }
    }
    
    render()
    {
        var this_component = this;
        
        return (
            <Loader ref={this_component.loader}>
                
                <div className="form-group form-row mb-2">
                    <div className="col-12 col-sm-12 col-md-6">
                        <Heading type="h2" color="primary" className="titleFont">Access Token</Heading>
                    </div>
                </div>
                
                <div className="form-group form-row mb-2">
                    <div className="col-12 col-sm-12 col-md-6">
                        <Heading type="h2" color="primary" className="textSize16 titleFont">Access token serves as secure password when exporting data to {config.texts.external_name}.</Heading>
                    </div>
                </div>
                
                <div className="form-group form-row mb-2">
                    <div className="col-12 col-sm-12 col-md-6 mb-2">
                        <TextField placeholder="token" className="form-control" size={TextField.sizes.MEDIUM} value={this_component.state.token} required={false} id="token" readonly={true} />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 mb-2">
                        <Tooltip content={"Copy token"} position={Tooltip.positions.BOTTOM}>
                            <Button onClick={(e) => this_component.copy(e)} type={Button.inputTags.BUTTON} kind={Button.kinds.PRIMARY} size={Button.sizes.MEDIUM} marginLeft={false} leftIcon={Duplicate}></Button>
                        </Tooltip>
                        <Button onClick={(e) => this_component.regenerate(e)} type={Button.inputTags.BUTTON} kind={Button.kinds.PRIMARY} size={Button.sizes.MEDIUM} marginLeft={true} leftIcon={Retry} loading={this_component.state.loading}>Regenerate</Button>
                    </div>
                </div>
                
                <p className="pb-3 pt-3" />
                
                <div className="form-group form-row mb-2">
                    <div className="col-12 col-sm-12 col-md-6">
                        <Heading type="h2" color="primary" className="textSize16 titleFont" ellipsis={false}>To speed up data export, use a personal access token. Go to the Main menu > Developers > My access tokens, click Show, copy the token, and paste it below. You’ll still need the access token to connect to {config.texts.short_name}.</Heading>
                    </div>
                </div>
                
                <div className="form-group form-row mb-2">
                    <div className="col-12 col-sm-12 col-md-6 mb-2">
                        {
                            (this_component.state.personal_token_valid==true)?null
                            :
                            <div className="mb-2"><Icon icon={Alert} style={{'color': "var(--color-error)", 'verticalAlign': 'sub'}} iconSize="19" />Validation error. Please enter a valid personal token</div>
                        }
                        <TextField placeholder="Personal Token" className="form-control" type={TextField.types.PASSWORD} size={TextField.sizes.MEDIUM} controlled={true} value={this_component.state.personal_token} required={false} id="personal_token" readonly={false} onChange={(value) => this_component.onChangePersonalToken(value)} />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 mb-2" style={{ 'display': 'flex' }}>
                         <Button onClick={(e) => this_component.savePersonalToken(e)} type={Button.inputTags.BUTTON} kind={Button.kinds.PRIMARY} size={Button.sizes.MEDIUM} marginLeft={false} loading={this_component.state.personal_loading} style={{ 'marginTop': 'auto' }}>Save</Button>
                        
                        <Tooltip content={"Revoke personal token"} position={Tooltip.positions.BOTTOM} referenceWrapperClassName="mt-auto">
                            <Button onClick={(e) => this_component.revokePersonalToken(e)} color={Button.colors.NEGATIVE} type={Button.inputTags.BUTTON} kind={Button.kinds.PRIMARY} size={Button.sizes.MEDIUM} marginLeft={true} loading={this_component.state.revoke_loading} style={{ }}>Revoke</Button>
                        </Tooltip> 
                    </div>
                </div>
                
                
                <div className="form-group form-row mb-2 mt-5 mr-1 d-flex justify-content-end">
                    <div className="col-1 col-sm-1 col-md-1 mb-2 text-right">
                        Account ID:
                    </div>
                    <div className="col-1 col-sm-1 col-md-1 mb-2">
                        {this_component.state.account_id}
                    </div>
                </div>
            </Loader>
        );
    }
    
}

AccessToken.defaultProps = {
};

export default withRouter(withAuth(AccessToken));
